import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Timeline from "../Timeline/Timeline";
import projectData from "./ProjectData";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading" style={{ paddingBottom: "10px" }}>
          我的<strong className="purple"> 项目 </strong>经历
        </h1>
        <p style={{ color: "rgba(255,255,255,0.6)", marginBottom: "10px" }}>
          以时间轴形式记录每个阶段的开发项目与工程实践。
        </p>
        <Timeline items={projectData} />
      </Container>
    </Container>
  );
}

export default Projects;
